import React from "react";
import styled, {css} from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const RTEWrapper = styled.div.attrs(({pFontSize}) => ({
    className: "RTEWrapper",
    pFontSize: pFontSize ? pFontSize : "16px"
}))`
    ${({narrowText}) =>
            narrowText &&
            css`
                max-width: 74%;
                padding-left: 11%;
                ${media.lessThan(breakpoints.mobile)`
        padding-left: 0;
        padding-right: 0;
        max-width: 100%;
      `}
            `}
    && {
        && {
            font-family: ${({theme}) => theme.font};
            line-height: 1.38;
            max-width: ${({maxWidth}) => (maxWidth ? maxWidth : "")};
            color: ${({color}) => (color ? color : "")};
            text-align: ${({textAlign}) => textAlign};
            margin: ${({margin}) => (margin ? margin : "")};

            p {
                color: ${({color}) => (color ? color : "")};

                margin-top: 0;
                margin: 0;
            }

            ol,
            ul {
                padding-left: 1rem;
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p {
                color: ${({color}) => (color ? color : "black")} !important;
                font-family: ${({theme}) => theme.font};
            }

            h1 {
                margin-top: 0;
                margin: 0 0 30px 0;
                margin-bottom: 30px;

                && {
                    font-size: 50px !important;
                    font-weight: bold;
                    line-height: 56px;
                    color: ${({color}) => (color ? color : "black")} !important;
                }

                @include mobile {
                    font-size: 36px;
                    line-height: 42px;
                }
            }

            h2 {
                && {
                    font-size: 32px;
                    line-height: 38px;
                    margin: 0;
                    font-weight: bold;
                    color: ${({color}) => (color ? color : "black")} !important;
                }

                @include mobile {
                    font-size: 24px;
                    line-height: 38px;
                }
            }

            h3 {
                && {
                    font-size: 24px;

                    line-height: 30px;
                    font-weight: bold;
                    margin: 0;

                    color: ${({color}) => (color ? color : "black")} !important;
                }

                @include mobile {
                    font-size: 20px;
                    line-height: 30px;
                }
            }

            p {
                font-size: ${({pFontSize}) => (pFontSize)};
                color: ${({color}) => (color ? color : "black")} !important;
            }

            h4 {
                && {
                    font-size: 24px;
                    line-height: 24px;
                    font-weight: bold;
                    margin: 0;

                    color: ${({color}) => (color ? color : "black")} !important;
                }

                @include mobile {
                    font-size: 16px;
                    line-height: 24px;
                }
            }

            li:before {
                color: ${({color, theme}) => (color ? color : theme.colors.primary)};
            }

            .rte-button {
                color: ${({color}) => (color ? color : "black")} !important;

                a {
                    transition: all 0.2s ease;
                    text-decoration: none;
                    align-items: center;
                    justify-content: center;
                    backface-visibility: hidden;
                    text-align: center;
                    font-weight: bold;
                    overflow: initial;
                    height: 30px;
                    width: fit-content;
                    border-radius: 20px;
                    padding: 0.1rem 1.5rem;
                    line-height: 22px;
                    border: ${({theme}) => `2px solid ${theme.colors.primary}`};
                    font-size: 18px;
                    color: ${({color, theme}) => (color ? color : "black")} !important;
                    font-family: calibri;

                    &:hover {
                        background-color: ${({theme}) => theme.colors.primary};
                        color: white;
                    }

                    @include mobile {
                        margin: 2rem 0 0 0;
                    }

                    &:focus {
                        outline-style: solid;
                        outline-offset: 5px;
                        outline-width: 2px;
                    }
                }
            }

            img {
                max-width: 100%;
                border-radius: ${({theme}) => theme.border.radius};
                height: 100%;

                &:before {
                    content: "";
                    display: block;
                    width: 100%;
                    padding-bottom: 56.25%;
                    overflow: hidden;
                }
            }

            ${media.lessThan(breakpoints.mobile)`
		img {
		width: 100%;
	}
`}
            a {
                display: inline-block;
                color: ${({color, theme}) => (color ? color : theme.colors.primary)};
                transition: all 0.2s ease;
                border-bottom: ${({color, theme}) =>
                        color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};

                img {
                    margin: 10px 0;
                    transition: all 0.2s ease;
                }

                :hover,
                :focus {
                    transition: all 0.2s ease;
                    border-color: ${({theme}) => theme.colors.none};

                    img {
                        transform: scale(1.02);
                    }
                }
            }

            .rte-img-button {
                display: flex;
                gap: 20px;

                a {
                    border-bottom: none;
                }

                img {
                    height: auto;
                    transition: all 0.2s ease;

                    &:hover,
                    &:focus {
                        transform: scale(1.02);
                    }
                }
            }

            ${media.greaterThan(breakpoints.ipad)`
		font-size: ${({fontSize}) => (fontSize ? fontSize : "")};
  `}
        }
    }
`;
